import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import type { OpenCallSubmission, OpenCallSubmissionsRequest } from "../types";
import { replaceSubmissionInQueryCache, submissionKeys } from "./queryKeys";

type DeletedSelectionParams = {
  deleted: boolean;
};

const updateSubmissionDeleted = (
  openCallId: string,
  submissionId: string,
  deleted: boolean,
) =>
  api.put<OpenCallSubmission>(`/open-call-submission/${openCallId}/delete`, {
    body: JSON.stringify({
      submissionId,
      undo: !deleted,
    }),
  });

/**
 * Custom hook to update existing OpenCall and manage state
 *
 * Needs the params for the request so we can update the cached query
 */
const useUpdateSubmissionDeleted = (
  openCallId: string,
  params: OpenCallSubmissionsRequest,
  submissionId: string,
) => {
  const queryClient = useQueryClient();
  const queryKey = submissionKeys.list(params);

  return useMutation(
    (formData: DeletedSelectionParams) =>
      updateSubmissionDeleted(openCallId, submissionId, formData.deleted),
    {
      onSuccess: (update) => {
        replaceSubmissionInQueryCache(queryClient, queryKey, update);
      },
    },
  );
};

export { useUpdateSubmissionDeleted };
